module.exports = __webpack_public_path__ + "img/yhq.71ff2b2e.png";